import AnimatedPopup from "../core/AnimatedPopup";
import Strings from "../core/data/Strings";
import ScaleManager from "../core/ScaleManager";
import PlayerData from "../PlayerData";
import GameScene from "../scenes/GameScene";
import { LevelData } from "../scenes/LevelSelectScene";
import ARIA from "../utils/ARIA";
import Fonts from "../utils/Fonts";
import GameColors from "../utils/GameColors";

export class RecapPopup extends AnimatedPopup {
	_onResize: () => void;
	scene: GameScene;
	text: Phaser.GameObjects.Text;
	particles: Phaser.GameObjects.Image[];
	level: LevelData;
	constructor(scene: GameScene, level: LevelData, score: number) {
		super(scene, 0, 0);
		this.scene = scene;
		this.level = level;
		this.setDepth(999);
		this.particles = [];
		const saveData = PlayerData.Instance.saveData;
		const overlay = (this._overlay = scene.add.sprite(0, 0, "popupOverlay"));
		overlay.setScale(Math.max(scene.viewport.width / overlay.width, scene.viewport.height / overlay.height));
		overlay.setInteractive();
		this.add(overlay);

		const emitters: Phaser.GameObjects.Particles.ParticleEmitter[] = [];

		for (const img of ["fallingSnow1", "fallingSnow2", "fallingSnow3"]) {
			const particle = this.scene.add.particles(img);
			this.particles.push();
			const emitter = particle.createEmitter({
				alpha: { start: 1, end: 0.0 },
				scale: { min: 0.7, max: 1 },
				frequency: 300,
				lifespan: 2500,
				gravityY: 300,
				speedX: { min: -50, max: 300 },
				speedY: { min: 150, max: 400 },
			});
			const topLeft = this.scene.viewport.getTopLeft();
			const topRight = this.scene.viewport.getTopRight();
			emitter.setPosition({ min: -topLeft.x, max: topRight.x }, { min: topLeft.y - 20, max: topLeft.y - 20 });

			emitters.push(emitter);
			emitter.start();
			this.add(particle);
		}
		this._popupGroup = scene.add.container(0, 0);
		this.add(this._popupGroup);

		this._popupGroup.add(this.particles);

		const totalScoreContainer = scene.add.container(0, 0);
		this.add(totalScoreContainer);
		const totalScore = scene.add.image(0, 0, "totalScoreBG");
		totalScoreContainer.setSize(totalScore.width, totalScore.height);

		const totalScoreText = scene.add.text(0, 0, saveData.totalScore.toFixed(), {
			fontFamily: Fonts.MontserratBold,
			fontSize: "58px",
			color: GameColors.WHITE,
			align: "left",
		});
		totalScoreText.setOrigin(0, 0.5);
		scene.alignIn.LeftCenter(totalScoreText, totalScore, -160, 0);
		totalScoreContainer.add([totalScore, totalScoreText]);

		const popupBG = scene.add.nineSlicedSprite(0, 0, "popupBG", 1250, 800, 50, 50, 50, 50, null, false);
		this._popupGroup.add(popupBG);

		const popupHeader = scene.add.image(0, 0, "popupHeader");
		this._popupGroup.add(popupHeader);

		const successText = (this.text = scene.add.text(0, 0, Strings.get("RecapHeader"), {
			fontFamily: Fonts.MontserratBold,
			fontSize: "70px",
			color: GameColors.WHITE,
			align: "Center",
		}));
		this._popupGroup.add(successText);

		const levels = scene.cache.json.get("levels") as LevelData[];
		const lvlIndex = levels.findIndex((l) => l.name == level.name) + 1;

		const levelTextBG = scene.add.image(0, 0, "smallTextHeader");
		const title = Strings.get("LevelComplete").replace("%N", lvlIndex.toString());
		const difficultyIcon = scene.add.image(0, 0, level.name + "RecapIcon");
		const levelText = scene.add.text(0, 0, title, {
			fontFamily: Fonts.MontserratBold,
			fontSize: "50px",
			color: GameColors.PURPLE,
			align: "Center",
		});
		this._popupGroup.add([levelTextBG, difficultyIcon, levelText]);

		const scoreBG = scene.add.image(0, 0, "popupScore");
		const scoreText = scene.add.text(0, 0, score.toFixed(), {
			fontFamily: Fonts.MontserratBold,
			fontSize: "70px",
			color: GameColors.WHITE,
			align: "center",
		});
		this._popupGroup.add([scoreBG, scoreText]);

		// Medal and Score
		const rays = this.scene.add.image(0, 0, "medalRays");
		const glow = this.scene.add.image(0, 0, "medalRayGlow");
		this._popupGroup.add([rays, glow]);

		this.scene.add.tween({
			targets: [rays, glow],
			alpha: { from: 0, to: 0.8 },
			scale: { from: 0, to: 1 },
			duration: 500,
			loopDelay: 500,
			ease: Phaser.Math.Easing.Quadratic.Out,
		});
		this.scene.add.tween({
			targets: rays,
			angle: 360,
			duration: 4500,
			repeat: 4,
		});

		const medal = scene.add.image(0, 0, "popupMedal");
		const newBestText = scene.add.image(0, 0, "popupNewBest").setAngle(25);
		this._popupGroup.add([medal, newBestText]);

		const corinne = scene.add.image(0, 0, "recapCorinne");
		this._popupGroup.add(corinne);

		//console.log("Score: " + score);
		//console.log("save data high score: " + saveData.highScores[level.name]);
		if (saveData.highScores[level.name] < score || saveData.highScores[level.name] == undefined) {
			saveData.highScores[level.name] = score;
			// show new best
			newBestText.setVisible(true);
		} else {
			newBestText.setVisible(false);
		}
		const levelsFinished = this.allLevelsCompleted;
		const certificateSeen = PlayerData.Instance.saveData.certificateSeen;

		const showCertificate = levelsFinished == true && certificateSeen == false ? true : false;
		// Always save here so that both a new score and the total score are saved
		PlayerData.Instance.save();

		// if (Grade.convertToScore(grade) > 8) {
		// 	medal.setVisible(true);
		// 	rays.setVisible(true);
		// 	glow.setVisible(true);
		// } else {
		// 	medal.setVisible(false);
		// 	rays.setVisible(false);
		// 	glow.setVisible(false);
		// }

		const replayBtn = scene.add.button(0, 0, "replayBtn", null, () => this.replay(), this, true);
		this._popupGroup.add(replayBtn);

		const homeBtn = scene.add.button(
			0,
			0,
			"nextBtn",
			null,
			showCertificate ? (): void => this.scene.createGameCompletePopup() : (): void => this.close(),
			this,
			true
		);
		this._popupGroup.add(homeBtn);

		replayBtn.setSize(homeBtn.width, homeBtn.height);
		replayBtn.setDisplaySize(homeBtn.width, homeBtn.height);

		this._onResize = (): void => {
			ScaleManager.ScaleBackgroundFromZone(overlay, scene.viewport);
			scene.alignIn.Center(overlay, scene.viewport);

			scene.alignIn.TopRight(totalScoreContainer, scene.viewport, -40, -40);

			scene.alignIn.Center(this._popupGroup, overlay, 0, -15);
			scene.alignTo.TopCenter(popupHeader, popupBG, 0, -70);
			scene.alignIn.TopCenter(successText, popupHeader, 0, -25);

			scene.alignIn.Center(levelTextBG, popupBG, 0, -240); // LUMI Hidden Object y: -250
			scene.alignIn.LeftCenter(difficultyIcon, levelTextBG, -30);
			scene.alignIn.Center(levelText, levelTextBG);

			scene.alignIn.Center(scoreBG, popupBG, 0, 0); // LUMI Hidden Object y: 50
			scene.alignIn.Center(scoreText, scoreBG);

			scene.alignTo.BottomCenter(replayBtn, popupBG, -150, -replayBtn.height * 0.75);
			scene.alignTo.BottomCenter(homeBtn, popupBG, 150, -homeBtn.height * 0.75);

			scene.alignTo.RightCenter(medal, scoreBG, -250);
			scene.alignIn.Center(rays, medal, 90, 65);
			scene.alignIn.Center(glow, medal, 90, 65);
			scene.alignTo.TopRight(newBestText, medal, 70, -100);

			scene.alignIn.BottomLeft(corinne, popupBG, corinne.width * 0.65, corinne.height * 0.38);

			const screenRatio = this.scene.viewport.width / this.scene.viewport.height;
			const goalRatio = 16 / 9;
			const ratioDif = screenRatio - goalRatio;
			if (screenRatio < goalRatio) {
				this._popupGroup.scale = 1 - ratioDif * ratioDif;
			}
		};
		this.resize();

		const ariaLayer = "recap-popup";
		ARIA.addTextWithObject(totalScore, `Total Score: ${totalScoreText.text}`, ariaLayer);
		successText.setARIA(ariaLayer, true);
		levelText.setARIA(ariaLayer);
		ARIA.addTextWithObject(scoreBG, `You Scored ${score.toFixed()} Points!`, ariaLayer);
		replayBtn.setARIA("Replay", ariaLayer);
		homeBtn.setARIA("Continue", ariaLayer);
		ARIA.showLayer(ariaLayer, true);

		this.intro();
	}

	get allLevelsCompleted(): boolean {
		const highScores = PlayerData.Instance.saveData.highScores;
		const levels = this.scene.cache.json.get("levels") as LevelData[];
		const scoreArray = [];
		for (const level of levels) {
			const highScore = highScores[level.name];
			if (highScore != undefined) {
				scoreArray.push(highScore);
			}
		}
		if (scoreArray.length == levels.length) return true;
		else return false;
	}

	replay(): void {
		this.scene.scene.start("PreloaderScene", { destinationScene: "GameScene", sceneState: { level: this.level } });
		this.scene.scene.stop(this.scene.scene.key);
	}

	close(): void {
		this.scene.scene.start("PreloaderScene", { destinationScene: "LevelSelectScene" });
		this.scene.scene.stop(this.scene.scene.key);
	}

	resize(): void {
		super.resize();
		if (this._onResize != null) this._onResize();
	}
}
